export default "__VITE_ASSET__Ct0v5Ea2__"